import { createApp } from 'vue';
import Nav from './Nav.vue';

/**
 * Initialize Vue 3 Navigation Component
 * 
 * This function mounts the Vue navigation component to the <nav> element.
 * The nav element contains a static loading skeleton that Vue will replace when ready.
 * This ensures instant visual feedback on page load (0ms delay).
 */
export function initVueNav() {
  const navElement = document.querySelector('nav');

  if (!navElement) {
    console.error('[Vue Nav] Navigation element not found');
    return;
  }

  // Don't clear innerHTML - let Vue take over the existing loading skeleton
  // This provides instant visual feedback (0ms) while Vue mounts

  // Create and mount Vue app (will replace loading skeleton)
  const app = createApp(Nav);
  app.mount(navElement);

  // console.log('[Vue Nav] Navigation component mounted successfully');
}

export default initVueNav;
